import { render, staticRenderFns } from "./card-table.vue?vue&type=template&id=0b13aaf8&scoped=true"
import script from "./card-table.vue?vue&type=script&lang=js"
export * from "./card-table.vue?vue&type=script&lang=js"
import style0 from "./card-table.vue?vue&type=style&index=0&id=0b13aaf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b13aaf8",
  null
  
)

export default component.exports